// 
import { createApp } from 'vue'
import RegionSummaryTable from '@/components/RegionSummaryTable.vue';
import TrackAgregateTable from '@/components/TrackAgregateTable.vue';
import EventAgregateTable from '@/components/EventAgregateTable.vue';
import AllTaskListView from '@/components/AllTaskListView.vue';
import InterviwerDaySummaryTable from '@/components/InterviewerDaySummaryTable.vue';
import AssignStatusRenderer from "@/components/AssignStatusRenderer.vue";
import StatusPopup from '@/components/StatusPopup.vue';
import MultipleStatusPopUp from '@/components/MultipleStatusPopUp.vue';
import CommentsPopup from '@/components/CommentsPopup.vue';
import DailyTaskListView from '@/components/DailyTaskListView.vue';
import ChartView from '@/components/ChartView.vue';
import RouteView from '@/components/RouteView.vue';
import ClientEventsView from '@/components/ClientEventsView.vue';
import BottomBarChart from '@/components/BottomBarChart.vue';
import LastReceived from '@/components/LastReceived.vue';
import PopUpTable from '@/components/PopUpTable.vue';
import LeafletMap from '@/components/LeafletMap.vue';
import LeafletMapLoader from '@/components/LeafletMapLoader.vue'
import AssignmentLeafletMap from '@/components/AssignmentLeafletMap.vue';
import DailyTasksInfo from '@/components/DailyTasksInfo.vue';
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

const app = createApp({
	// options here
})

app.component('TrackAgregateTable', TrackAgregateTable);
app.component('EventAgregateTable', EventAgregateTable);
app.component('AllTaskListView', AllTaskListView);
app.component('RegionSummaryTable', RegionSummaryTable);
app.component('InterviewerDaySummaryTable', InterviwerDaySummaryTable);
app.component('StatusPopup', StatusPopup);
app.component('MultipleStatusPopUp', MultipleStatusPopUp);
app.component('CommentsPopup', CommentsPopup);
app.component('DailyTaskListView', DailyTaskListView);
app.component('ChartView', ChartView);
app.component('RouteView', RouteView);
app.component('ClientEventsView', ClientEventsView);
app.component('BottomBarChart', BottomBarChart);
app.component('LastReceived', LastReceived);
app.component('PopUpTable', PopUpTable);
app.component('LeafletMap', LeafletMap);
app.component('LeafletMapLoader', LeafletMapLoader);
app.component('AssignmentLeafletMap', AssignmentLeafletMap);
app.component('DailyTasksInfo', DailyTasksInfo);
app.component('Footer', Footer);
app.component('Header', Header);

// Vue.component('TrackAgregateTable', TrackAgregateTable);
// Vue.component('AllTaskListView', AllTaskListView);
// Vue.component('RegionSummaryTable', RegionSummaryTable);
// Vue.component('InterviewerDaySummaryTable', InterviwerDaySummaryTable);
// Vue.component('AssignStatusRenderer', AssignStatusRenderer);
// Vue.component('StatusPopup', StatusPopup);
// Vue.component('MultipleStatusPopUp', MultipleStatusPopUp);
// Vue.component('CommentsPopup', CommentsPopup);
// Vue.component('DailyTaskListView', DailyTaskListView);
// Vue.component('ChartView', ChartView);
// Vue.component('RouteView', RouteView);
// Vue.component('BottomBarChart', BottomBarChart);
// Vue.component('LastReceived', LastReceived);
// Vue.component('PopUpTable', PopUpTable);
// Vue.component('LeafletMap', LeafletMap);
// Vue.component('LeafletMapLoader', LeafletMapLoader);
// Vue.component('AssignmentLeafletMap', AssignmentLeafletMap);
// Vue.component('DailyTasksInfo', DailyTasksInfo);
// Vue.component('Footer', Footer);
// Vue.component('Header', Header);


